import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { isTablet, MobileView, BrowserView } from 'react-device-detect'
import { Card, List, Collapse } from 'core/components/ui'
import { configuratorShape } from '../../shapes'

import TypeColorItem from './type-color-item'

const { Panel } = Collapse

const StyledPanel = styled(Panel)`
  margin: 0 0 15px 0;
`

const TypeColor = props => {
  const { configurator, loading } = props
  const { designList, design } = configurator
  const { exterior } = designList
  const { type } = exterior
  const typeSelected = design.exterior.type

  const renderItem = item => (
    <List.Item>
      <TypeColorItem item={item} />
    </List.Item>
  )

  const RenderHeader = () =>
    typeSelected ? (
      <div style={{ width: '100%' }}>
        <TypeColorItem item={typeSelected} showCheckBox={false} />
      </div>
    ) : (
      <FormattedMessage id="configurator-design-type-color-placeholder" />
    )

  return (
    <>
      {!isTablet && (
        <BrowserView>
          <Card bordered={false} data-test="component-configurator-design-type-color">
            <List
              data-test="configurator-design-type-color-list"
              dataSource={type}
              renderItem={item => renderItem(item)}
              loading={loading}
            />
          </Card>
        </BrowserView>
      )}
      <MobileView>
        <Collapse expandIconPosition="right" bordered={false}>
          <StyledPanel header={<RenderHeader />}>
            <List
              data-test="configurator-design-type-color-list"
              dataSource={type}
              renderItem={item => renderItem(item)}
              loading={loading}
            />
          </StyledPanel>
        </Collapse>
      </MobileView>
    </>
  )
}

TypeColor.propTypes = {
  configurator: configuratorShape.isRequired,
  loading: PropTypes.bool.isRequired
}

export default TypeColor
